// extracted by mini-css-extract-plugin
module.exports = {"divider":"idt-uploadmethods_divider__1aj59"};